import React from 'react';
import vegIcon from '../svg/vegIcon.svg';
const VegIcon = () => {
  return <img src={vegIcon} style={{ width: 12, height: 12 }} />;
};

export default VegIcon;
